<div class="row mt-1" *ngIf="showLabel">
  <div class="col">
    <h5 class="{{menu.fontHeader}} m-0" [ngStyle]="{'color': color}"><i class="fas fa-star mr-1"></i>
      {{ lang === 'ES'? 'Recomendado': 'Recommended'}}
    </h5>
  </div>
</div>